import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Table } from 'react-bootstrap'
import { CommonAxiosGet, CommonAxiosPut } from '../../CommonUtils/CommonAxios';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import * as Yup from "yup";
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import axios from 'axios';
import Cookies from "js-cookie";
export default function InspClosureOfInst() {
    const validationSchema = Yup.object({
        closureList: Yup.array().of(
            Yup.object({
                recommended: Yup.string().required("Required")
            })
        )
    });
    const formik = useFormik({
        initialValues: {
            closureList: []
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: (values) => {
            submitInspClosureInst(values)
        }
    });
    const [getInstData, setInstData] = useState([])
    function getInspectionClosureDetails() {
        let url = config.url.FAC_URL + "getClosureData"
        CommonAxiosGet(url).then((res) => {
            if (res !== null && res.data.status === true) {
                setInstData(res.data.closureData)
                let data = res.data.closureData
                if (data.length > 0) {
                    formik.setValues({
                        closureList: data.map(data => ({
                            instCode: data.inst_code,
                            instName: data.inst_name,
                            recommended: data.recommended_status || "",
                            sno: data.sno
                        }))
                    })
                }
            }
            else {
                setInstData([])
            }
        })
            .catch((e) => {
                console.error(e);
                setInstData([]);
            })
    }
    const token = Cookies.get("token");
    function submitInspClosureInst(values) {

        const item = values.closureList[0];
        console.log("token", token)
        const payload = {
            sno: item.sno,
            recommendedStatus: item.recommended
        };

        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to submit?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Submit",
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (result.isConfirmed) {

                let url = config.url.FAC_URL + "updateClosureRecommendedStatus";
                // axios.put(url, payload, {
                //     headers: {
                //         Authorization: `Bearer ${token}`,
                //         "Content-Type": "application/json"
                //     }
                // })
                CommonAxiosPut(url, payload)
                    .then((res) => {
                        if (res && res.data.status === true) {
                            if (res.data.scode === "01") {
                                successAlert2(res.data.sdesc);
                                getInspectionClosureDetails();
                            } else {
                                failureAlert(res.data.sdesc);
                            }
                        } else {
                            failureAlert("Submission Failed");
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        failureAlert("Something went wrong!");
                    });

            }
        });
    }
    useEffect(() => {
        getInspectionClosureDetails();
    }, [])
    return (
        <>
            <Container fluid className="py-3">
                <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                        <h5 className="mb-3 innerheader-new text-success">
                            <span> Closure Of Institution</span>
                        </h5>
                        <Row className="mt-4">
                            <Col xs={12}>
                                <Table bordered responsive>
                                    <thead className='table-primary'>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Insitute Code</th>
                                            <th> Name Of The Insitute</th>
                                            <th>Recommended For Progressive/Complete Closure(Yes/No)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {console.log("getInstData", getInstData)}
                                        {getInstData && getInstData.length > 0 ?
                                            getInstData.map((data, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{data.coll_code}</td>
                                                    <td>{data.inst_name}</td>
                                                    <td className="text-center">
                                                        <div className="d-flex justify-content-center gap-3">

                                                            <label>
                                                                <Field
                                                                    type="radio"
                                                                    name={`closureList.${index}.recommended`}
                                                                    value="YES"
                                                                  disabled={!!getInstData[index]?.recommended_status}
                                                                /> &nbsp;Yes
                                                            </label>

                                                            <label>
                                                                <Field
                                                                    type="radio"
                                                                    name={`closureList.${index}.recommended`}
                                                                    value="NO"
                                                                  disabled={!!getInstData[index]?.recommended_status}
                                                                />&nbsp; No
                                                            </label>

                                                        </div>

                                                        <ErrorMessage
                                                            name={`closureList.${index}.recommended`}
                                                            component="div"
                                                            className="text-danger small"
                                                        />
                                                    </td>
                                                </tr>
                                            )) : (<tr>
                                                <td colSpan="4" className="text-center text-danger">
                                                    ***** No Data Found *****
                                                </td>
                                            </tr>)}

                                    </tbody>
                                </Table>
                                <Row className="mt-4">
                                    <Col xs={12} className="text-end">

                                        {getInstData.some(item => !item.recommended_status) ? (
                                            <button type="submit" className="btn btn-primary">
                                                Submit
                                            </button>
                                        ) : (
                                            <span className="text-success fw-bold">
                                                Already Submitted
                                            </span>
                                        )}

                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </FormikProvider>
            </Container>

        </>
    )
}
